import { render, staticRenderFns } from "./DeleteSiteAttributes.vue?vue&type=template&id=05cffe64&scoped=true"
import script from "./DeleteSiteAttributes.vue?vue&type=script&lang=js"
export * from "./DeleteSiteAttributes.vue?vue&type=script&lang=js"
import style0 from "./DeleteSiteAttributes.vue?vue&type=style&index=0&id=05cffe64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cffe64",
  null
  
)

export default component.exports